import {} from 'actions/routines/createApiRoutine';
import { FetchService } from 'services';
import { getItemAttachmentDeleteEndpoint } from 'services/api/itemEndpoints';
export async function deleteItemAttachment(itemId, attachmentId, options = {}) {
    const config = {
        ...options,
        endpoint: getItemAttachmentDeleteEndpoint(itemId, attachmentId),
        method: 'DELETE',
        requireAuth: true,
        setRequester: true,
    };
    return FetchService.request(config);
}
